import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Grid,
  Paper,
  Typography,
  Autocomplete,
  MenuItem,
  Button,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  LinearProgress,
  Modal,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  ListItemText,
  Checkbox,
  Card,
  CardContent,
  Tooltip,
  Switch,
  FormControlLabel,
} from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import ReplyIcon from "@mui/icons-material/Reply";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import QRCode from "qrcode";
// import { saveAs } from "file-saver";
import { makeStyles } from "@mui/styles";
import { BASE_URL, signDoctors, WIDAL_COLUMNS } from "../../../constants";
import Chip from "@mui/material/Chip";
import { format } from "date-fns";
import Avatar from "@mui/material/Avatar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Loader from "./Loader";
import EditNoteIcon from "@mui/icons-material/EditNote";
// import ReactQuill from "react-quill";
import UpdateIcon from "@mui/icons-material/Update";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { getFinancialYearDates } from "../../../utils/common";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { faUserNurse } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";
import Widal from "./Widal";
import { useRecoilValue } from "recoil";
import { widalInterpretationState } from "../../../recoil/authAtom";
import { toast } from "react-toastify";

import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";

const useStyles = makeStyles({
  headerText: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#333",
  },
});
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function getStyles(name, doctorName, theme) {
  return {
    fontWeight: doctorName.includes(name)
      ? theme?.typography?.fontWeightMedium
      : theme?.typography?.fontWeightRegular,
  };
}

const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};

Quill.register({ "modules/table-better": QuillTableBetter }, true);
const Pathology = () => {
  const theme = useTheme();
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const stateTab = location?.state?.tab || null;
  const widalReport = location?.state?.widalReport || null;
  const report = location?.state?.report || null;
  const sentInvoice = location?.state?.sentInvoice || null;
  const sentSelectedMethods = location?.state?.sentSelectedMethods || null;
  const reportId = location?.state?.reportId || null;
  const requestType = location?.state?.reqType || null;
  const doctorSignatory = location?.state?.doctorSignatory || null;
  const techSignatory = location?.state?.techSignatory || null;
  const widalDoctorSignatory = location?.state?.widalDoctorSignatory || null;
  const widalTechSignatory = location?.state?.widalTechSignatory || null;

  const normalDate = location?.state?.sampleCollectedDate || null;
  const normalTime = location?.state?.sampleCollectedTime || null;
  const widalDate = location?.state?.widalSampleCollectedDate || null;
  const widalTime = location?.state?.widalSampleCollectedTime || null;

  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [investigations, setInvestigations] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [doctorName, setDoctorName] = useState([]);
  const [widalDoctorName, setWidalDoctorName] = useState([]);
  const [techniciansName, setTechniciansName] = useState([]);
  const [widalTechniciansName, setWidalTechniciansName] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [sampleCollectedDate, setSampleCollectedDate] = useState();
  //format(new Date(), "MMMM d, yyyy")
  const [sampleCollectedTime, setSampleCollectedTime] = useState();
  //format(new Date(), "hh:mm a")
  const [widalSampleCollectedDate, setWidalSampleCollectedDate] = useState();
  //format(new Date(), "MMMM d, yyyy")
  const [widalSampleCollectedTime, setWidalSampleCollectedTime] = useState();
  //format(new Date(), "hh:mm a")
  const [note, setNote] = useState("");
  const [openNoteModal, setOpenNoteModal] = useState(false);
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedMethods, setSelectedMethods] = useState({});
  const [resultRecord, setResultRecord] = useState(null);
  const [notesInvestigation, setNotesInvestigation] = useState(null);
  const [outsideTest, setOutsideTest] = useState(null);
  const [reqType, setRequestType] = useState("");
  const [openNotesInvestigation, setOpenNotesInvestigation] = useState(false);
  const [formattedFromDate, setFormattedFromDate] = useState(
    getFormattedCurrentDate(),
  );
  const [formattedToDate, setFormattedToDate] = useState(
    getFormattedCurrentDate(),
  );
  const [widalFormData, setWidalFormData] = useState({});
  const [widalInterpretation, setWidalInterpretation] = useState("");

  const [maxDoctor, setMaxDoctor] = useState(1);

  const quillRef = useRef(null);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link", "image"],
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          // ['tableUI']
          // ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    [],
  );

  useEffect(() => {
    const date = new Date(selectedInvoice?.createdAt);
    const formattedIST = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
    setSampleCollectedDate(selectedInvoice?.billingDate);
    setSampleCollectedTime(formattedIST);
    setWidalSampleCollectedDate(selectedInvoice?.createdAt);
    setWidalSampleCollectedTime(formattedIST);
    if (report) {
      setTab(stateTab === "normal" ? 0 : 1);
      setInvestigations(report);
      setResultRecord(report);
      setSelectedInvoice(sentInvoice);
      setSelectedMethods(sentSelectedMethods);
      setRequestType(requestType);

      setSampleCollectedDate(normalDate);
      setSampleCollectedTime(normalTime);
      setWidalSampleCollectedDate(widalDate);
      setWidalSampleCollectedTime(widalTime);

      const doctorSignatoryNames = doctorSignatory?.map(
        (doctor) => doctor.doctor._id,
      );
      setDoctorName(doctorSignatoryNames);
      const techSignatoryNames = techSignatory?.map(
        (tech) => tech.technician._id,
      );
      setTechniciansName(techSignatoryNames);

      setWidalFormData({
        testId: widalReport?.testId,
        data: widalReport?.data,
        comment: widalReport?.comment,
      });

      // setWidalInterpretation(widalReport?.interpretation);

      const widalDoctorSignatoryNames = widalDoctorSignatory?.map(
        (doctor) => doctor.doctor._id,
      );
      setWidalDoctorName(widalDoctorSignatoryNames);
      const widalTechSignatoryNames = widalTechSignatory?.map(
        (tech) => tech.technician._id,
      );
      setWidalTechniciansName(widalTechSignatoryNames);
    }
  }, [report, selectedInvoice]);

  // useEffect(() => {
  //   if (report || widalReport) {
  //     setTab(stateTab);
  //     if (stateTab === 0) {
  //       setInvestigations(report);
  //       setResultRecord(report);
  //       setSelectedInvoice(sentInvoice);
  //       setSelectedMethods(sentSelectedMethods);
  //       setRequestType(requestType);
  //       const doctorSignatoryNames = doctorSignatory.map(
  //         (doctor) => doctor.doctor._id
  //       );
  //       setDoctorName(doctorSignatoryNames);
  //       const techSignatoryNames = techSignatory.map(
  //         (tech) => tech.technician._id
  //       );
  //       setTechniciansName(techSignatoryNames);
  //     } else if (stateTab === 1) {
  //       setSelectedInvoice(sentInvoice);
  //       setRequestType(requestType);
  //       setWidalFormData({
  //         testId: widalReport?.testId,
  //         data: widalReport?.data,
  //       });
  //     }
  //   }
  // }, [report]);

  const hamdleOpenNoteModal = (item) => {
    setNotesInvestigation(item);
    setOpenNotesInvestigation(true);
  };
  const handleOutsideTest = (item) => {
    setOutsideTest(item);

    const updatedData = resultRecord.map((testItem) => {
      if (testItem.testId._id === item.testId._id) {
        return {
          ...testItem,
          testId: {
            ...testItem.testId,
            isOutside: !testItem.testId.isOutside,
          },
        };
      }
      return testItem;
    });

    setResultRecord(updatedData);
  };

  const fetchAllInvoices = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/pathology/get-all-pathology-invoices?startDate=${
          getFinancialYearDates().startDate
        }&endDate=${getFinancialYearDates().endDate}&invoiceFor=pathology`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();

      setInvoices(data.invoices);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
  };

  const fetchAllPathologyDoctors = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-dept-signatory-doctors?cat=Pathology`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setDoctors(data.doctors);
      setMaxDoctor(data.doctorCount || 1);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
    }
  };
  const fetchAllTechnician = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-all-technicians`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (data.success) {
        setTechnicians(data.technicians);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
    }
  };
  useEffect(() => {
    fetchAllInvoices();
    fetchAllPathologyDoctors();
    fetchAllTechnician();
  }, []);

  const fetchInvestigations = async (ids) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/pathology/get-pathology-investigation-for-testIDs`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ testIDs: ids }),
        },
      );
      const data = await response.json();

      const normal = data?.investigations?.filter(
        (inv) => inv?.testId?.reportType === "Normal",
      );
      setInvestigations(normal);

      const widals = data?.investigations?.filter(
        (inv) => inv?.testId?.reportType === "Widal",
      );
      // setWidalInvestigations(widals[0].widalInvestigations);
      if (widals[0]?.widalInvestigations.length > 0) {
        // setWidalFormData(
        //   (testId = widals[0].testId),
        //   widals[0]?.widalInvestigations.map((inv) => ({
        //     testId: inv.testId,
        //     name: inv.name,
        //     ...WIDAL_COLUMNS.reduce((acc, col) => ({ ...acc, [col]: "-" }), {}),
        //   }))
        // );
        setWidalFormData({
          testId: widals[0].testId,
          data: widals[0]?.widalInvestigations.map((inv) => ({
            testId: inv.testId,
            name: inv.name,
            ...WIDAL_COLUMNS.reduce((acc, col) => ({ ...acc, [col]: "-" }), {}),
          })),
          comment: widals[0].comment,
        });
      }
      const normals = data?.investigations?.filter(
        (inv) => inv?.testId?.reportType === "Normal",
      );
      setResultRecord(normals);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const ids = selectedInvoice?.tests?.map((test) => test.testId._id);
    ids && fetchInvestigations(ids);
  }, [selectedInvoice]);

  const formatDateAndTime = (timestamp) => {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      //   second: "2-digit",
    });

    return `${formattedDate} ${formattedTime}`;
  };

  const handleMethodChange = (id, methodId) => {
    setSelectedMethods({
      ...selectedMethods,
      [id]: methodId,
    });
  };
  const getGender = (gender) => {
    if (gender === "Male") return "M";
    if (gender === "Female") return "F";
    if (gender === "Both") return "B";
    return "";
  };

  const getRanges1 = (method) => {
    const selectedGender = selectedInvoice?.patientId?.gender;
    const selectedAge = calculateAge(selectedInvoice.patientId?.dob);

    if (!method?.ranges || method.ranges.length === 0) {
      return "";
    }
    // Extract numeric value and unit from the selectedAge string
    const ageMatch = selectedAge.match(/(\d+)\s*(days|months|years?)/i);
    if (!ageMatch) {
      return "";
    }

    const parsedAge = parseInt(ageMatch[1], 10);
    const ageUnit = ageMatch[2].toLowerCase();

    if (isNaN(parsedAge)) {
      return "";
    }

    // Convert age to equivalent years, months, or days
    let ageInDays = parsedAge;
    if (ageUnit === "months") ageInDays *= 30; // Approximate conversion
    if (ageUnit === "years") ageInDays *= 365;

    // Filter ranges based on gender and age conditions
    const filteredRanges = method.ranges.filter((range) => {
      if (range.gender !== selectedGender && range.gender !== "Both") {
        return false;
      }
      if (range.min === null || range.max === null) {
        return false;
      }

      // Convert range limits to days for comparison
      let fromInDays = parseInt(range.fromValue, 10);
      let toInDays = parseInt(range.toValue, 10);

      if (range.fromUnit === "months") fromInDays *= 30;
      if (range.fromUnit === "years") fromInDays *= 365;
      if (range.toUnit === "months") toInDays *= 30;
      if (range.toUnit === "years") toInDays *= 365;
      // > from, <= to
      return ageInDays >= fromInDays && ageInDays <= toInDays;
    });

    if (filteredRanges.length === 0) {
      return "";
    }

    if (
      filteredRanges.length === 1 &&
      filteredRanges[0].gender === "Both" &&
      method.ranges.every((range) => range.gender === "Both")
    ) {
      return `${getGender(filteredRanges[0].gender)}: ${
        filteredRanges[0].min
      } - ${filteredRanges[0].max}`;
    }

    return filteredRanges
      .map((range) => `${getGender(range.gender)}: ${range.min} - ${range.max}`)
      .join(" | ");
  };

  const parseAge = (ageStr) => {
    const age = { years: 0, months: 0, days: 0 };
    const matchYear = ageStr.match(/(\d+)\s*Y/i);
    const matchMonth = ageStr.match(/(\d+)\s*M/i);
    const matchDay = ageStr.match(/(\d+)\s*D/i);

    if (matchYear) age.years = parseInt(matchYear[1], 10);
    if (matchMonth) age.months = parseInt(matchMonth[1], 10);
    if (matchDay) age.days = parseInt(matchDay[1], 10);

    return age;
  };

  // const compareAges = (a, b) => {
  //   if (a.years !== b.years) return a.years - b.years;
  //   if (a.months !== b.months) return a.months - b.months;
  //   return a.days - b.days;
  // };

  // const getRanges = (method) => {
  //   const selectedGender = selectedInvoice?.patientId?.gender;
  //   const selectedAge = calculateAge(selectedInvoice.patientId?.dob); // e.g., "1Y 1M 0D"
  //   const age = parseAge(selectedAge);

  //   if (!method?.ranges || method.ranges.length === 0) {
  //     return "";
  //   }
  //   const filteredRanges = method.ranges.filter((range) => {
  //     if (range.gender !== selectedGender && range.gender !== "Both")
  //       return false;
  //     if (range.min == null || range.max == null) return false;

  //     const from = { years: 0, months: 0, days: 0 };
  //     const to = { years: 0, months: 0, days: 0 };

  //     const fromVal = parseInt(range.fromValue, 10);
  //     const toVal = parseInt(range.toValue, 10);

  //     if (range.fromUnit === "years") from.years = fromVal;
  //     else if (range.fromUnit === "months") from.months = fromVal;
  //     else if (range.fromUnit === "days") from.days = fromVal;

  //     if (range.toUnit === "years") to.years = toVal;
  //     else if (range.toUnit === "months") to.months = toVal;
  //     else if (range.toUnit === "days") to.days = toVal;

  //     return compareAges(age, from) >= 0 && compareAges(age, to) <= 0;
  //   });

  //   if (filteredRanges.length === 0) return "";

  //   if (
  //     filteredRanges.length === 1 &&
  //     filteredRanges[0].gender === "Both" &&
  //     method.ranges.every((range) => range.gender === "Both")
  //   ) {
  //     return `${getGender(filteredRanges[0].gender)}: ${
  //       filteredRanges[0].min
  //     } - ${filteredRanges[0].max}`;
  //   }

  //   return filteredRanges
  //     .map((range) => `${getGender(range.gender)}: ${range.min} - ${range.max}`)
  //     .join(" | ");
  // };
  // Converts an age object into comparable total days
  const ageToDays = (age) => age.years * 365 + age.months * 30 + age.days;
  const compareAges = (a, b) => ageToDays(a) - ageToDays(b);

  const getRanges = (method) => {
    const selectedGender = selectedInvoice?.patientId?.gender;
    const selectedAge = calculateAge(selectedInvoice.patientId?.dob); // e.g., "17Y 0M 0D"
    const age = parseAge(selectedAge); // { years: 17, months: 0, days: 0 }

    if (!method?.ranges || method.ranges.length === 0) return "";

    const filteredRange = method.ranges.find((range) => {
      if (range.gender !== selectedGender && range.gender !== "Both")
        return false;
      if (range.min == null || range.max == null) return false;

      const from = { years: 0, months: 0, days: 0 };
      const to = { years: 0, months: 0, days: 0 };

      const fromVal = parseInt(range.fromValue, 10);
      const toVal = parseInt(range.toValue, 10);

      if (range.fromUnit === "years") from.years = fromVal;
      else if (range.fromUnit === "months") from.months = fromVal;
      else if (range.fromUnit === "days") from.days = fromVal;

      if (range.toUnit === "years") to.years = toVal;
      else if (range.toUnit === "months") to.months = toVal;
      else if (range.toUnit === "days") to.days = toVal;

      return compareAges(age, from) >= 0 && compareAges(age, to) <= 0;
    });

    if (!filteredRange) return "";

    return `${getGender(filteredRange.gender)}: ${filteredRange.min} - ${
      filteredRange.max
    }`;
  };

  // const getUnit = (method) => {
  //   const selectedGender = selectedInvoice?.patientId?.gender;
  //   const selectedAge = calculateAge(selectedInvoice.patientId?.dob);

  //   if (!method?.ranges || method.ranges.length === 0) {
  //     return "";
  //   }

  //   const ageMatch = selectedAge.match(/(\d+)\s*(days|months|years?)/i);
  //   if (!ageMatch) {
  //     return "";
  //   }

  //   const parsedAge = parseInt(ageMatch[1], 10);
  //   const ageUnit = ageMatch[2].toLowerCase();

  //   if (isNaN(parsedAge)) {
  //     return "";
  //   }

  //   let ageInDays = parsedAge;
  //   if (ageUnit === "months") ageInDays *= 30;
  //   if (ageUnit === "years") ageInDays *= 365;

  //   const filteredRanges = method.ranges.filter((range) => {
  //     if (range.gender !== selectedGender && range.gender !== "Both") {
  //       return false;
  //     }
  //     let fromInDays = parseInt(range.fromValue, 10);
  //     let toInDays = parseInt(range.toValue, 10);

  //     if (range.fromUnit === "months") fromInDays *= 30;
  //     if (range.fromUnit === "years") fromInDays *= 365;
  //     if (range.toUnit === "months") toInDays *= 30;
  //     if (range.toUnit === "years") toInDays *= 365;

  //     return ageInDays >= fromInDays && ageInDays <= toInDays;
  //   });

  //   if (filteredRanges.length === 0) {
  //     return "";
  //   }

  //   // If all ranges have the same unit and apply to both genders
  //   if (
  //     filteredRanges.length === 1 &&
  //     filteredRanges[0].gender === "Both" &&
  //     method.ranges.every((range) => range.gender === "Both")
  //   ) {
  //     return filteredRanges[0].unit;
  //   }
  //   // Return the units mapped to gender
  //   return filteredRanges.map((range) => `${range.unit}`).join(" | ");
  // };

  const getUnit = (method) => {
    const selectedGender = selectedInvoice?.patientId?.gender;
    const selectedAge = calculateAge(selectedInvoice.patientId?.dob); // e.g., "1Y 1M 0D"
    const age = parseAge(selectedAge); // { years: 1, months: 1, days: 0 }

    if (!method?.ranges || method.ranges.length === 0) return "";

    const matchingRange = method.ranges.find((range) => {
      if (range.gender !== selectedGender && range.gender !== "Both")
        return false;

      const from = { years: 0, months: 0, days: 0 };
      const to = { years: 0, months: 0, days: 0 };

      const fromVal = parseInt(range.fromValue, 10);
      const toVal = parseInt(range.toValue, 10);

      if (range.fromUnit === "years") from.years = fromVal;
      else if (range.fromUnit === "months") from.months = fromVal;
      else if (range.fromUnit === "days") from.days = fromVal;

      if (range.toUnit === "years") to.years = toVal;
      else if (range.toUnit === "months") to.months = toVal;
      else if (range.toUnit === "days") to.days = toVal;

      return compareAges(age, from) >= 0 && compareAges(age, to) <= 0;
    });

    if (!matchingRange) return "";

    return matchingRange.unit;
  };

  const getNote = (method) => {
    const isNotePresent = method?.ranges?.filter(
      (range) => range?.note?.length > 0,
    );
    if (isNotePresent?.length > 0) {
      const note = method?.ranges
        ?.map((range, indx) => `(${indx + 1}) ${range?.note}`)
        .join(" ");
      return note;
    }
  };

  const handleOpenDialog = (note) => {
    const fetchedNote = note;
    setNote(fetchedNote);
    setOpenNoteModal(true);
  };

  const handleCloseDialog = () => {
    setOpenNoteModal(false);
  };

  const handleDateChange = (newDate) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format("MMMM D, YYYY");
      setSampleCollectedDate(formattedDate);
    }
    //setOpenModal(false);
  };

  const handleTimeChange = (newDate) => {
    if (newDate) {
      // Format the selected time as hh:mm AM/PM
      const formattedTime = format(new Date(newDate), "hh:mm a");
      setSampleCollectedTime(formattedTime);
    }
  };

  const handleWidalDateChange = (newDate) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format("MMMM D, YYYY");
      setWidalSampleCollectedDate(formattedDate);
    }
    //setOpenModal(false);
  };

  const handleWidalTimeChange = (newDate) => {
    if (newDate) {
      // Format the selected time as hh:mm AM/PM
      const formattedTime = format(new Date(newDate), "hh:mm a");
      setWidalSampleCollectedTime(formattedTime);
    }
  };

  const handleResultChange1 = (
    value,
    testIndx,
    investigationIndx,
    subIndx,
    method,
    investigationType,
  ) => {
    if (investigationType === "investigation") {
      const updatedData = resultRecord.map((test, tIndex) => {
        if (tIndex === testIndx) {
          return {
            ...test,
            investigations: test.investigations.map((investigation, iIndex) => {
              if (iIndex === investigationIndx) {
                return {
                  ...investigation,
                  methods: investigation.methods.map((met) => {
                    if (met?.methodName === method?.methodName) {
                      return { ...met, result: value };
                    }
                    return met;
                  }),
                };
              }
              return investigation;
            }),
          };
        }
        return test;
      });

      setResultRecord(updatedData);
    } else if (investigationType === "sub-investigation") {
      const updatedData = resultRecord.map((test, tIndex) => {
        if (tIndex === testIndx) {
          return {
            ...test,
            investigations: test.investigations.map((investigation, iIndex) => {
              if (iIndex === investigationIndx) {
                return {
                  ...investigation,
                  subInvestigations: investigation.subInvestigations.map(
                    (sub, sIndex) => {
                      if (sIndex === subIndx) {
                        return {
                          ...sub,
                          methods: sub.methods.map((met) => {
                            if (met?.methodName === method?.methodName) {
                              return { ...met, result: value };
                            }
                            return met;
                          }),
                        };
                      }
                      return sub;
                    },
                  ),
                };
              }
              return investigation;
            }),
          };
        }
        return test;
      });

      setResultRecord(updatedData);
    }
  };

  const handleResultChange2 = (
    value,
    testIndx,
    investigationIndx,
    subIndx,
    method,
    investigationType,
  ) => {
    // Convert input value to a number
    const numericValue = parseFloat(value);

    if (!method || isNaN(numericValue)) return;

    // Get the applicable range
    const ranges = method?.ranges || [];

    const selectedGender = selectedInvoice?.patientId?.gender;
    const selectedAge = calculateAge(selectedInvoice.patientId?.dob);

    // Extract numeric age value
    const ageMatch = selectedAge.match(/(\d+)\s*(days|months|years?)/i);
    if (!ageMatch) return;

    let parsedAge = parseInt(ageMatch[1], 10);
    let ageUnit = ageMatch[2].toLowerCase();

    if (isNaN(parsedAge)) return;

    // Convert age to days for easier comparison
    let ageInDays = parsedAge;
    if (ageUnit === "months") ageInDays *= 30;
    if (ageUnit === "years") ageInDays *= 365;

    // Find the correct range based on gender and age
    const validRange = ranges.find((range) => {
      if (range.gender !== selectedGender && range.gender !== "Both") {
        return false;
      }

      // Convert range limits to days
      let fromInDays = parseInt(range.fromValue, 10);
      let toInDays = parseInt(range.toValue, 10);

      if (range.fromUnit === "months") fromInDays *= 30;
      if (range.fromUnit === "years") fromInDays *= 365;
      if (range.toUnit === "months") toInDays *= 30;
      if (range.toUnit === "years") toInDays *= 365;

      return ageInDays >= fromInDays && ageInDays <= toInDays;
    });

    // If a valid range is found, check if the value is within the min-max range
    if (validRange) {
      const min = Number(validRange.min);
      const max = Number(validRange.max);

      // Ensure both min and max are valid numbers
      if (
        !isNaN(min) &&
        !isNaN(max) &&
        (numericValue < min || numericValue > max)
      ) {
        alert(`Value must be between ${min} and ${max} ${validRange.unit}`);
        //return; // Prevent updating state
      }
    }

    // Existing logic for updating state
    if (investigationType === "investigation") {
      const updatedData = resultRecord.map((test, tIndex) => {
        if (tIndex === testIndx) {
          return {
            ...test,
            investigations: test.investigations.map((investigation, iIndex) => {
              if (iIndex === investigationIndx) {
                return {
                  ...investigation,
                  methods: investigation.methods.map((met) => {
                    if (met?.methodName === method?.methodName) {
                      return { ...met, result: value };
                    }
                    return met;
                  }),
                };
              }
              return investigation;
            }),
          };
        }
        return test;
      });

      setResultRecord(updatedData);
    } else if (investigationType === "sub-investigation") {
      const updatedData = resultRecord.map((test, tIndex) => {
        if (tIndex === testIndx) {
          return {
            ...test,
            investigations: test.investigations.map((investigation, iIndex) => {
              if (iIndex === investigationIndx) {
                return {
                  ...investigation,
                  subInvestigations: investigation.subInvestigations.map(
                    (sub, sIndex) => {
                      if (sIndex === subIndx) {
                        return {
                          ...sub,
                          methods: sub.methods.map((met) => {
                            if (met?.methodName === method?.methodName) {
                              return { ...met, result: value };
                            }
                            return met;
                          }),
                        };
                      }
                      return sub;
                    },
                  ),
                };
              }
              return investigation;
            }),
          };
        }
        return test;
      });

      setResultRecord(updatedData);
    }
  };

  const handleResultChange = (
    value,
    testIndx,
    investigationIndx,
    subIndx,
    method,
    investigationType,
  ) => {
    if (!isNaN(value) && value.trim() !== "") {
      const numericValue = parseFloat(value);
      // if (!method || isNaN(numericValue)) return;
      if (!method) return;
      const ranges = method?.ranges || [];
      const selectedGender = selectedInvoice?.patientId?.gender;
      const selectedAge = calculateAge(selectedInvoice.patientId?.dob); // e.g., "17Y 0M 0D"
      const age = parseAge(selectedAge); // { years: 17, months: 0, days: 0 }
      const compareAges = (a, b) => {
        if (a.years !== b.years) return a.years - b.years;
        if (a.months !== b.months) return a.months - b.months;
        return a.days - b.days;
      };

      const validRange = ranges.find((range) => {
        if (range.gender !== selectedGender && range.gender !== "Both") {
          return false;
        }

        const from = { years: 0, months: 0, days: 0 };
        const to = { years: 0, months: 0, days: 0 };

        const fromVal = parseInt(range.fromValue, 10);
        const toVal = parseInt(range.toValue, 10);

        if (range.fromUnit === "years") from.years = fromVal;
        else if (range.fromUnit === "months") from.months = fromVal;
        else if (range.fromUnit === "days") from.days = fromVal;

        if (range.toUnit === "years") to.years = toVal;
        else if (range.toUnit === "months") to.months = toVal;
        else if (range.toUnit === "days") to.days = toVal;

        // Use strict upper bound to avoid overlapping
        return compareAges(age, from) >= 0 && compareAges(age, to) < 0;
      });

      let outOfRange = false;
      if (!validRange) {
        // No valid range found
        outOfRange = true;
      } else if (validRange.min == null && validRange.max == null) {
        outOfRange = false;
      } else if (value < validRange.min || value > validRange.max) {
        outOfRange = true;
      }
      if (investigationType === "investigation") {
        const updatedData = resultRecord.map((test, tIndex) => {
          if (tIndex === testIndx) {
            return {
              ...test,
              investigations: test.investigations.map(
                (investigation, iIndex) => {
                  if (iIndex === investigationIndx) {
                    return {
                      ...investigation,
                      methods: investigation.methods.map((met) => {
                        let newMethod = { ...met, result: "" }; // Set result to empty
                        delete newMethod.outOfRange; // Remove outOfRange key
                        if (met?.methodName === method?.methodName) {
                          newMethod.result = value; // Set new result
                          newMethod.outOfRange = outOfRange; // Add back outOfRange
                        }
                        return newMethod;
                      }),
                    };
                  }
                  return investigation;
                },
              ),
            };
          }
          return test;
        });
        setResultRecord(updatedData);
      } else if (investigationType === "sub-investigation") {
        const updatedData = resultRecord.map((test, tIndex) => {
          if (tIndex === testIndx) {
            return {
              ...test,
              investigations: test.investigations.map(
                (investigation, iIndex) => {
                  if (iIndex === investigationIndx) {
                    return {
                      ...investigation,
                      subInvestigations: investigation.subInvestigations.map(
                        (sub, sIndex) => {
                          if (sIndex === subIndx) {
                            return {
                              ...sub,
                              methods: sub.methods.map((met) => {
                                let newMethod = { ...met, result: "" }; // Set result to empty
                                delete newMethod.outOfRange; // Remove outOfRange key
                                if (met?.methodName === method?.methodName) {
                                  newMethod.result = value; // Set new result
                                  newMethod.outOfRange = outOfRange; // Add back outOfRange
                                }
                                return newMethod;
                              }),
                            };
                          }
                          return sub;
                        },
                      ),
                    };
                  }
                  return investigation;
                },
              ),
            };
          }
          return test;
        });

        setResultRecord(updatedData);
      }
    } else {
      if (investigationType === "investigation") {
        const updatedData = resultRecord.map((test, tIndex) => {
          if (tIndex === testIndx) {
            return {
              ...test,
              investigations: test.investigations.map(
                (investigation, iIndex) => {
                  if (iIndex === investigationIndx) {
                    return {
                      ...investigation,
                      methods: investigation.methods.map((met) => {
                        let newMethod = { ...met, result: "" }; // Set result to empty
                        delete newMethod.outOfRange; // Remove outOfRange key
                        if (met?.methodName === method?.methodName) {
                          newMethod.result = value; // Set new result
                          //   newMethod.outOfRange = outOfRange; // Add back outOfRange
                        }
                        return newMethod;
                      }),
                    };
                  }
                  return investigation;
                },
              ),
            };
          }
          return test;
        });

        setResultRecord(updatedData);
      } else if (investigationType === "sub-investigation") {
        const updatedData = resultRecord.map((test, tIndex) => {
          if (tIndex === testIndx) {
            return {
              ...test,
              investigations: test.investigations.map(
                (investigation, iIndex) => {
                  if (iIndex === investigationIndx) {
                    return {
                      ...investigation,
                      subInvestigations: investigation.subInvestigations.map(
                        (sub, sIndex) => {
                          if (sIndex === subIndx) {
                            return {
                              ...sub,
                              methods: sub.methods.map((met) => {
                                let newMethod = { ...met, result: "" }; // Set result to empty
                                delete newMethod.outOfRange; // Remove outOfRange key
                                if (met?.methodName === method?.methodName) {
                                  newMethod.result = value; // Set new result
                                  //   newMethod.outOfRange = outOfRange; // Add back outOfRange
                                }
                                return newMethod;
                              }),
                            };
                          }
                          return sub;
                        },
                      ),
                    };
                  }
                  return investigation;
                },
              ),
            };
          }
          return test;
        });

        setResultRecord(updatedData);
      }
    }
  };

  const handleResultChange4 = (
    value,
    testIndx,
    investigationIndx,
    subIndx,
    method,
    investigationType,
  ) => {
    if (!isNaN(value) && value.trim() !== "") {
      const numericValue = parseFloat(value);
      if (!method || isNaN(numericValue)) return;

      const ranges = method?.ranges || [];
      const selectedGender = selectedInvoice?.patientId?.gender;
      const selectedAge = calculateAge(selectedInvoice.patientId?.dob);
      const ageMatch = selectedAge.match(/(\d+)\s*(days|months|years?)/i);
      if (!ageMatch) return;

      let parsedAge = parseInt(ageMatch[1], 10);
      let ageUnit = ageMatch[2].toLowerCase();
      if (isNaN(parsedAge)) return;

      let ageInDays = parsedAge;
      if (ageUnit === "months") ageInDays *= 30;
      if (ageUnit === "years") ageInDays *= 365;

      const validRange = ranges.find((range) => {
        if (range.gender !== selectedGender && range.gender !== "Both") {
          return false;
        }
        let fromInDays = parseInt(range.fromValue, 10);
        let toInDays = parseInt(range.toValue, 10);
        if (range.fromUnit === "months") fromInDays *= 30;
        if (range.fromUnit === "years") fromInDays *= 365;
        if (range.toUnit === "months") toInDays *= 30;
        if (range.toUnit === "years") toInDays *= 365;
        return ageInDays >= fromInDays && ageInDays <= toInDays;
      });

      let outOfRange = false;
      if (validRange) {
        const lowerLimit = parseFloat(validRange.lowerLimit);
        const upperLimit = parseFloat(validRange.upperLimit);
        if (numericValue < lowerLimit || numericValue > upperLimit) {
          outOfRange = true;
        }
      }

      if (investigationType === "investigation") {
        const updatedData = resultRecord.map((test, tIndex) => {
          if (tIndex === testIndx) {
            return {
              ...test,
              investigations: test.investigations.map(
                (investigation, iIndex) => {
                  if (iIndex === investigationIndx) {
                    return {
                      ...investigation,
                      methods: investigation.methods.map((met) => {
                        let newMethod = { ...met, result: "" }; // Set result to empty
                        delete newMethod.outOfRange; // Remove outOfRange key
                        if (met?.methodName === method?.methodName) {
                          newMethod.result = value; // Set new result
                          newMethod.outOfRange = outOfRange; // Add back outOfRange
                        }
                        return newMethod;
                      }),
                    };
                  }
                  return investigation;
                },
              ),
            };
          }
          return test;
        });

        setResultRecord(updatedData);
      } else if (investigationType === "sub-investigation") {
        const updatedData = resultRecord.map((test, tIndex) => {
          if (tIndex === testIndx) {
            return {
              ...test,
              investigations: test.investigations.map(
                (investigation, iIndex) => {
                  if (iIndex === investigationIndx) {
                    return {
                      ...investigation,
                      subInvestigations: investigation.subInvestigations.map(
                        (sub, sIndex) => {
                          if (sIndex === subIndx) {
                            return {
                              ...sub,
                              methods: sub.methods.map((met) => {
                                let newMethod = { ...met, result: "" }; // Set result to empty
                                delete newMethod.outOfRange; // Remove outOfRange key
                                if (met?.methodName === method?.methodName) {
                                  newMethod.result = value; // Set new result
                                  newMethod.outOfRange = outOfRange; // Add back outOfRange
                                }
                                return newMethod;
                              }),
                            };
                          }
                          return sub;
                        },
                      ),
                    };
                  }
                  return investigation;
                },
              ),
            };
          }
          return test;
        });

        setResultRecord(updatedData);
      }
    }
  };

  const displayResult = (
    testIndx,
    investigationIndx,
    subIndx,
    method,
    investigationType,
  ) => {
    if (!resultRecord || resultRecord.length === 0) return "";

    const test = resultRecord[testIndx];
    if (!test) return "";

    const investigation = test.investigations[investigationIndx];
    if (!investigation) return "";

    if (investigationType === "investigation") {
      const foundMethod = investigation.methods.find(
        (met) => met?.methodName === method?.methodName,
      );
      return foundMethod?.result || "";
    } else if (investigationType === "sub-investigation") {
      const subInvestigation = investigation.subInvestigations[subIndx];
      if (!subInvestigation) return "";

      const foundMethod = subInvestigation.methods.find(
        (met) => met?.methodName === method?.methodName,
      );
      return foundMethod?.result || "";
    }

    return "";
  };

  const handleNoteChange = (value) => {
    const updatedData = resultRecord.map((testItem) => {
      // Check if the testId._id matches the investigation.testId._id
      if (testItem.testId._id === notesInvestigation.testId._id) {
        return {
          ...testItem,
          testId: {
            ...testItem.testId,
            note: value, // Add the note here in the testId
          },
        };
      }
      return testItem;
    });

    setResultRecord(updatedData); // Set the updated data in state
  };
  const removeMethodsWithoutResult = (data) => {
    return data.map((entry) => ({
      ...entry,
      investigations: entry.investigations.map((investigation) => ({
        ...investigation,
        methods: investigation.methods.filter((method) =>
          method.hasOwnProperty("result"),
        ),
        subInvestigations: investigation.subInvestigations.map(
          (subInvestigation) => ({
            ...subInvestigation,
            methods: subInvestigation.methods.filter((method) =>
              method.hasOwnProperty("result"),
            ),
          }),
        ),
      })),
    }));
  };
  const submitResult1 = async () => {
    try {
      //   const records = removeMethodsWithoutResult(resultRecord);
      setOpenPrintModal(true);
      const result = {
        patientId: selectedInvoice?.patientId._id,
        doctorId: selectedInvoice?.doctorId._id,
        sampleCollectedDate,
        sampleCollectedTime,
        result: [...resultRecord],
        reportType: "pathology",
        invoice: selectedInvoice._id,
      };
      // removeMethodsWithoutResult(resultRecord);
      const response = await fetch(
        `${BASE_URL}api/user/pathology/create-result-record`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ reportData: result }),
        },
      );
      const data = await response.json();
      if (data.success) {
        alert("Results submitted successfully.");
      } else {
        alert("Failed to submit results.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
  };

  //   function sortByTestDept(data) {
  //     let groupedData = data.map((item) => {
  //       item.investigations.forEach((investigation) => {
  //         if (investigation.methods && investigation.methods.length > 0) {
  //           investigation.methods = investigation.methods.filter(
  //             (method) => method.result !== ""
  //           );
  //         }
  //       });
  //       if (!item.testId || !item.testId.testDept) return item;
  //       item.testId.testDept = item.testId.testDept.toLowerCase();

  //       return item;
  //     });
  //     const groupedByDept = groupedData.reduce((acc, item) => {
  //       const dept = item.testId.testDept;
  //       if (!acc[dept]) {
  //         acc[dept] = {
  //           testId: item.testId,
  //           investigations: [],
  //         };
  //       }
  //       acc[dept].investigations.push(...item.investigations);
  //       return acc;
  //     }, {});

  //     const result = Object.values(groupedByDept);
  //     return result.sort((a, b) => {
  //       let deptA = a.testId.testDept.toLowerCase();
  //       let deptB = b.testId.testDept.toLowerCase();
  //       return deptA.localeCompare(deptB);
  //     });
  //   }

  function sortByTestDept(data) {
    let groupedData = data.map((item) => {
      item.investigations.forEach((investigation) => {
        if (investigation.methods && investigation.methods.length > 0) {
          investigation.methods = investigation.methods.filter(
            (method) => method.result !== "",
          );
        }
        if (
          investigation.subInvestigations &&
          investigation.subInvestigations.length > 0
        ) {
          investigation.subInvestigations.forEach((subInvestigation) => {
            if (
              subInvestigation.methods &&
              subInvestigation.methods.length > 0
            ) {
              subInvestigation.methods = subInvestigation.methods.filter(
                (method) => method.result !== "",
              );
            }
          });
        }
      });
      // Handle testId's testDept
      if (!item.testId || !item.testId.testDept) return item;
      item.testId.testDept = item.testId.testDept.toLowerCase();

      return item;
    });

    const groupedByDept = groupedData.reduce((acc, item) => {
      const dept = item.testId.testDept;
      if (!acc[dept]) {
        acc[dept] = {
          testId: item.testId,
          investigations: [],
        };
      }
      acc[dept].investigations.push(...item.investigations);
      return acc;
    }, {});

    const result = Object.values(groupedByDept);
    return result.sort((a, b) => {
      let deptA = a.testId.testDept.toLowerCase();
      let deptB = b.testId.testDept.toLowerCase();
      return deptA.localeCompare(deptB);
    });
  }

  function groupTestsByDept(data) {
    const groupedByDept = {};
    data.forEach((item) => {
      const dept = item.testId.testDept;
      if (!groupedByDept[dept]) {
        groupedByDept[dept] = [];
      }
      groupedByDept[dept].push({
        department: dept,
        testId: item.testId,
        investigations: item.investigations,
      });
    });
    return Object.values(groupedByDept);
  }

  function updateInUse1(result) {
    const selectedGender = selectedInvoice?.patientId?.gender;
    const selectedAge = calculateAge(selectedInvoice.patientId?.dob);
    // Extract numeric value and unit from selectedAge string
    const ageMatch = selectedAge.match(/(\d+)\s*(days|months|years?)/i);
    if (!ageMatch) return result; // Return original result if age format is invalid

    let parsedAge = parseInt(ageMatch[1], 10);
    let ageUnit = ageMatch[2].toLowerCase();

    // Convert selectedAge to days for uniform comparison
    let ageInDays = parsedAge;
    if (ageUnit === "months") ageInDays *= 30; // Approximate conversion
    if (ageUnit === "years") ageInDays *= 365;

    result.forEach((testGroups) => {
      testGroups.forEach((test) => {
        test.investigations.forEach((investigation) => {
          investigation.methods.forEach((method) => {
            method.ranges.forEach((range) => {
              let fromInDays = parseInt(range.fromValue, 10);
              let toInDays = parseInt(range.toValue, 10);

              // Convert range values to days
              if (range.fromUnit === "months") fromInDays *= 30;
              if (range.fromUnit === "years") fromInDays *= 365;
              if (range.toUnit === "months") toInDays *= 30;
              if (range.toUnit === "years") toInDays *= 365;

              // Check if age falls within the range and gender matches
              if (
                ageInDays >= fromInDays &&
                ageInDays <= toInDays &&
                (range.gender === "Both" || range.gender === selectedGender)
              ) {
                range.inUse = true;
              } else {
                range.inUse = false; // Reset inUse for non-matching ranges
              }
            });
          });
        });
      });
    });

    return result; // Return the modified result
  }
  function updateInUse(result) {
    const selectedGender = selectedInvoice?.patientId?.gender;
    const selectedAge = calculateAge(selectedInvoice.patientId?.dob);

    // Extract numeric value and unit from selectedAge string
    const ageMatch = selectedAge.match(/(\d+)\s*(days|months|years?)/i);
    if (!ageMatch) return result; // Return original result if age format is invalid

    let parsedAge = parseInt(ageMatch[1], 10);
    let ageUnit = ageMatch[2].toLowerCase();

    // Convert selectedAge to days for uniform comparison
    let ageInDays = parsedAge;
    if (ageUnit === "months") ageInDays *= 30; // Approximate conversion
    if (ageUnit === "years") ageInDays *= 365;

    result.forEach((testGroups) => {
      testGroups.forEach((test) => {
        test.investigations.forEach((investigation) => {
          // Update ranges for methods in investigations
          investigation.methods.forEach((method) => {
            method.ranges.forEach((range) => {
              let fromInDays = parseInt(range.fromValue, 10);
              let toInDays = parseInt(range.toValue, 10);

              // Convert range values to days
              if (range.fromUnit === "months") fromInDays *= 30;
              if (range.fromUnit === "years") fromInDays *= 365;
              if (range.toUnit === "months") toInDays *= 30;
              if (range.toUnit === "years") toInDays *= 365;

              // Check if age falls within the range and gender matches
              range.inUse =
                ageInDays >= fromInDays &&
                ageInDays <= toInDays &&
                (range.gender === "Both" || range.gender === selectedGender);
            });
          });
          // Process subInvestigations
          investigation.subInvestigations.forEach((subInvestigation) => {
            subInvestigation.methods.forEach((method) => {
              method.ranges.forEach((range) => {
                let fromInDays = parseInt(range.fromValue, 10);
                let toInDays = parseInt(range.toValue, 10);

                // Convert range values to days
                if (range.fromUnit === "months") fromInDays *= 30;
                if (range.fromUnit === "years") fromInDays *= 365;
                if (range.toUnit === "months") toInDays *= 30;
                if (range.toUnit === "years") toInDays *= 365;

                // Check if age falls within the range and gender matches
                range.inUse =
                  ageInDays >= fromInDays &&
                  ageInDays <= toInDays &&
                  (range.gender === "Both" || range.gender === selectedGender);
              });
            });
          });
        });
      });
    });

    return result; // Return the modified result
  }

  function removeEmptyResults1(data) {
    return data.map((group) => {
      return group.map((test) => {
        return {
          ...test,
          investigations: test.investigations.map((investigation) => {
            return {
              ...investigation,
              methods: investigation.methods.filter(
                (method) => method.result !== "",
              ),
            };
          }),
        };
      });
    });
  }
  function removeEmptyResults(data) {
    return data.map((group) => {
      return group.map((test) => {
        return {
          ...test,
          investigations: test.investigations
            .map((investigation) => {
              return {
                ...investigation,
                methods: investigation.methods.filter(
                  (method) => method.result !== "",
                ),
                subInvestigations: investigation.subInvestigations
                  .map((subInvestigation) => {
                    return {
                      ...subInvestigation,
                      methods: subInvestigation.methods.filter(
                        (method) => method.result !== "",
                      ),
                    };
                  })
                  .filter(
                    (subInvestigation) => subInvestigation.methods.length > 0,
                  ), // Remove subInvestigations with empty methods
              };
            })
            .filter(
              (investigation) =>
                investigation.methods.length > 0 ||
                investigation.subInvestigations.length > 0,
            ), // Remove investigations with empty methods and subInvestigations
        };
      });
    });
  }

  const generatePDF = async (header, results) => {
    try {
      const templatePdfBytes = await fetch(
        "https://res.cloudinary.com/dotuhpjuq/image/upload/v1738728703/LITSS_PDF_fihyah.pdf",
      ).then((res) => res.arrayBuffer());
      const templatePdf = await PDFDocument.load(templatePdfBytes);
      const pdfDoc = await PDFDocument.create();
      const addTemplatePage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
        return pdfDoc.addPage(templatePage);
      };
      results = groupTestsByDept(results);
      const inUseResult = updateInUse(results);
      const finalResult = removeEmptyResults(inUseResult);
      return pdfDoc;
    } catch (error) {
      console.error("Error generating PDF:", error);
      return null;
    }
  };

  const submitResult = async () => {
    try {
      // Prepare JSON data
      setSubmitLoading(true);
      if (doctorName.length === 0) {
        alert("Please select at least one doctor");
        return;
      }
      if (techniciansName.length === 0) {
        alert("Please select at least one technician");
        return;
      }

      const result = {
        patientId: selectedInvoice?.patientId._id,
        doctorId: selectedInvoice?.doctorId._id,
        sampleCollectedDate,
        sampleCollectedTime,
        result: [...resultRecord],
        reportType: "pathology",
        invoice: selectedInvoice._id,
        doctorSignatory: doctorName,
        techSignatory: techniciansName,
      };
      // return;
      // Generate PDF (Uncomment this for LIVE)
      //   const pdfDoc = await generatePDF(selectedInvoice, resultRecord);
      //   if (!pdfDoc) {
      //     alert("Failed to generate PDF.");
      //     return;
      //   }

      //   const pdfBytes = await pdfDoc.save();
      //   const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

      //This is for testing-----------------------------------------------
      //   const pdfDoc = await generatePDF(selectedInvoice, resultRecord);
      //   if (!pdfDoc) {
      //     alert("Failed to generate PDF.");
      //     return;
      //   }

      //   const pdfBytes = await pdfDoc.save();
      //   const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      //   const pdfUrl = URL.createObjectURL(pdfBlob);

      //   // Open the PDF in a new tab
      //   const newTab = window.open(pdfUrl, "_blank");
      //   if (newTab) {
      //     newTab.focus();
      //   } else {
      //     alert("Please allow pop-ups for this website.");
      //   }
      // ----------------------------------------------------------------------------
      // Create FormData
      //   const formData = new FormData();
      //   formData.append("reportData", JSON.stringify(result));
      //formData.append("pdfFile", pdfBlob, "report.pdf");

      // Send request
      const response = await fetch(
        `${BASE_URL}api/user/pathology/create-result-record`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(result), // Send as multipart/form-data
        },
      );

      const data = await response.json();
      if (!data.success) {
        toast.warning(data.message);
        return;
      }
      if (data.success) {
        toast.success("Results submitted successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        handlePrint(data.data.reportFileUrl);
      } else {
        toast.error("Failed to submit results.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong! Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const submitWidalResult = async () => {
    try {
      // Prepare JSON data
      setSubmitLoading(true);
      if (widalDoctorName.length === 0) {
        alert("Please select at least one doctor");
        return;
      }
      if (widalTechniciansName.length === 0) {
        alert("Please select at least one technician");
        return;
      }
      // const widalData = {
      //   ...widalFormData,
      //   interpretation: widalInterpretation,
      // };
      // return;
      const result = {
        patientId: selectedInvoice?.patientId._id,
        doctorId: selectedInvoice?.doctorId._id,
        widalSampleCollectedDate,
        widalSampleCollectedTime,
        result: widalFormData,
        reportType: "widal",
        invoice: selectedInvoice._id,
        widalDoctorSignatory: widalDoctorName,
        widalTechSignatory: widalTechniciansName,
      };
      const response = await fetch(
        `${BASE_URL}api/user/pathology/create-widal-report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(result), // Send as multipart/form-data
        },
      );

      const data = await response.json();
      if (data.success) {
        alert("Results submitted successfully.");
        window.location.reload();
        handlePrint(data.data.reportFileUrl);
      } else {
        alert("Failed to submit results.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const updateResult = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/pathology/update-pathology-result-record/${reportId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ reportData: resultRecord }),
        },
      );
      const data = await response.json();
      if (data.success) {
        alert("Results updated successfully.");
      } else {
        alert("Failed to update results.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
  };

  const updateWidalResult = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/pathology/update-widal-report/${reportId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            result: {
              ...widalFormData,
              widalDoctorSignatory: widalDoctorName,
              widalTechSignatory: widalTechniciansName,
              widalSampleCollectedDate,
              widalSampleCollectedTime,
            },
          }),
        },
      );
      const data = await response.json();
      if (data.success) {
        alert("Results updated successfully.");
      } else {
        alert("Failed to update results.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
  };

  const approvalOfReport = async (status) => {
    try {
      let requestBody = { status };
      if (status === 2) {
        const reason = prompt(
          "Please provide a reason for resending the report:",
        );
        if (!reason) {
          alert("Reason is required to resend the report.");
          return;
        }
        requestBody.note = reason;
      } else {
        requestBody.reportId = reportId;
        const confirmation = window.confirm(
          "Are you sure you want to approve this report?",
        );
        if (!confirmation) {
          return;
        }
      }
      setSubmitLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/pathology/tech-action-on-pathology-report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();
      if (data.success) {
        alert(data.message);
      } else {
        alert("Failed to update results.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["blockquote"],
    [{ script: "sub" }, { script: "super" }],
    [{ size: ["small", "medium", "large", "huge"] }],
  ];

  const calculateAge1 = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();
    const diffInDays = today.diff(birthDate, "days");
    if (diffInDays < 30) {
      return `${diffInDays} days`;
    }
    let months = today.diff(birthDate, "months");
    if (today.date() < birthDate.date()) {
      months--;
    }
    if (months < 12) {
      return `${months} months`;
    }
    let years = Math.floor(months / 12);
    return `${years} years`;
  };

  // const calculateAge = (dob) => {
  //   //if (!dob) return "Enter a valid DOB";
  //   const birthDate = dayjs(dob, "DD-MM-YY");
  //   //if (!birthDate.isValid()) return "Invalid DOB format";
  //   const now = dayjs();
  //   const years = now.diff(birthDate, "year");
  //   const months = now.diff(birthDate.add(years, "year"), "month");
  //   const days = now.diff(
  //     birthDate.add(years, "year").add(months, "month"),
  //     "day"
  //   );
  //   return `${years}Y ${months}M ${days}D`;
  // };
  const calculateAge = (dob) => {
    // Parse correctly using format "MMMM DD, YYYY"
    const birthDate = dayjs(dob, "MMMM DD, YYYY");

    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    const days = now.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const [typingTimeout, setTypingTimeout] = useState(null);

  const calculateAgeforPrint = (dob) => {
    if (!dob) return "Enter a valid DOB";
    const birthDate = dayjs(dob); // Auto-detect format
    if (!birthDate.isValid()) return "Invalid DOB format";
    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    const days = now.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const handlePrint = async (pdfUrl) => {
    try {
      const response = await fetch(pdfUrl, { mode: "cors" });
      if (!response.ok) {
        throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
      }
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("pdf")) {
        throw new Error("Fetched file is not a valid PDF.");
      }
      const existingPdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const qrCodeDataUrl = await QRCode.toDataURL(pdfUrl);
      const qrImage = await pdfDoc.embedPng(qrCodeDataUrl);
      const { width, height } = firstPage.getSize();
      firstPage.drawImage(qrImage, {
        x: width - 100, // Adjust position
        y: 700, // Adjust position
        width: 80,
        height: 80,
      });
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const newTab = window.open(blobUrl, "_blank");
      if (newTab) {
        newTab.focus();
      } else {
        alert("Please allow pop-ups for this website.");
      }
    } catch (error) {
      console.error("Error fetching or processing PDF:", error);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setDoctorName(typeof value === "string" ? value.split(",") : value);
  };
  const handleChange2 = (event) => {
    const {
      target: { value },
    } = event;
    setTechniciansName(typeof value === "string" ? value.split(",") : value);
  };

  const widalHandleChange = (event) => {
    const {
      target: { value },
    } = event;
    setWidalDoctorName(typeof value === "string" ? value.split(",") : value);
  };
  const widalHandleChange2 = (event) => {
    const {
      target: { value },
    } = event;
    setWidalTechniciansName(
      typeof value === "string" ? value.split(",") : value,
    );
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [tab, setTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <Box>
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Change sample collected date</DialogTitle>
          <DialogContent
            sx={{
              paddingTop: "10px !important",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Appointment Date"
                value={
                  tab === 0
                    ? sampleCollectedDate
                      ? dayjs(sampleCollectedDate, "MMMM D, YYYY")
                      : null
                    : widalSampleCollectedDate
                      ? dayjs(widalSampleCollectedDate, "MMMM D, YYYY")
                      : null
                }
                onChange={tab === 0 ? handleDateChange : handleWidalDateChange}
                format="DD.MM.YYYY"
                maxDate={dayjs()}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Appointment Time"
                onChange={tab == 0 ? handleTimeChange : handleWidalTimeChange}
                value={
                  tab === 0
                    ? sampleCollectedTime
                      ? dayjs(sampleCollectedTime, "MMMM D, YYYY")
                      : null
                    : widalSampleCollectedTime
                      ? dayjs(widalSampleCollectedTime, "MMMM D, YYYY")
                      : null
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </DialogContent>
        </Dialog>

        <Modal
          open={openNotesInvestigation}
          onClose={() => setOpenNotesInvestigation(false)}
        >
          <Box
            sx={{
              position: "absolute",
              top: "30%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "70%",
              bgcolor: "background.paper",
              border: "2px solid #000",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            {/* <ReactQuill
              value={
                resultRecord?.find(
                  (item) => item?._id === notesInvestigation?._id
                )?.testId?.note
              }
              onChange={handleNoteChange}
              readOnly={reqType === "approval"}
              placeholder="Define the test structure..."
              modules={{
                toolbar: toolbarOptions,
              }}
              style={{ marginTop: 10 }}
            /> */}
            <ReactQuill
              ref={quillRef}
              // theme="snow"
              modules={modules}
              value={
                resultRecord?.find(
                  (item) => item?._id === notesInvestigation?._id,
                )?.testId?.note
              }
              onChange={handleNoteChange}
              readOnly={reqType === "approval"}
              placeholder="Define the test structure..."
            />
          </Box>
        </Modal>

        <Dialog
          open={openPrintModal}
          onClose={() => setOpenPrintModal(false)}
          maxWidth="xs"
          //   fullWidth
        >
          <DialogTitle>Do you want to print?</DialogTitle>
          <DialogContent
            sx={{ display: "flex", justifyContent: "space-around" }}
          >
            <Button
              variant="text"
              color="error"
              onClick={() => setOpenPrintModal(false)}
            >
              Cancel
            </Button>
            <IconButton onClick={handlePrint}>
              <LocalPrintshopIcon
                sx={{ fontSize: "2.2rem", color: "#38b000" }}
              />
            </IconButton>
          </DialogContent>
        </Dialog>
        <Dialog
          open={openNoteModal}
          onClose={() => setOpenNoteModal(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Note</DialogTitle>
          <DialogContent
            sx={{
              paddingTop: "10px !important",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {note}
          </DialogContent>
        </Dialog>
        {/* Dropdown for Selecting Invoice */}
        {!report && invoices?.length > 0 && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={invoices}
                getOptionLabel={(option) =>
                  `${option?.invoiceId} (${option?.patientId?.name} ~ ${option?.patientId?.patientID})`
                }
                onChange={(event, newValue) => {
                  setSelectedInvoice(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Invoice"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disableClearable
              />
            </Grid>
          </Grid>
        )}

        {/* Jumbotron Section */}
        {!loading ? (
          <>
            {selectedInvoice &&
              (investigations || widalFormData.data.length > 0) && (
                <>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      mt: 2,
                      backgroundColor: "#f5f5f5",
                      borderLeft: "5px solid #1976d2",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" gutterBottom>
                          <strong>Name:</strong>{" "}
                          {selectedInvoice.patientId?.name}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                          <strong>Age:</strong>{" "}
                          {calculateAge(selectedInvoice.patientId?.dob)}{" "}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                          <strong>Gender:</strong>{" "}
                          {selectedInvoice.patientId?.gender}
                        </Typography>
                        <Typography variant="subtitle1">
                          <strong>Ref By:</strong>{" "}
                          {selectedInvoice.doctorId?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1">
                          <strong>Registration ID: </strong>{" "}
                          {selectedInvoice.patientId?.patientID}
                        </Typography>
                        <Typography variant="subtitle1">
                          <strong style={{ marginRight: "3px" }}>
                            Registration Date:
                          </strong>{" "}
                          {formatDateAndTime(
                            selectedInvoice.patientId?.createdAt,
                          )}
                        </Typography>
                        {/* <Typography variant="subtitle1" sx={{ display: "flex" }}>
                  <strong>Sample Collected: </strong> {sampleCollectedDate}{" "}
                  <Typography
                    sx={{
                      color: "blue",
                      fontSize: "12px",
                      cursor: "pointer",
                      marginLeft: 1,
                      "&:hover": { color: "green" },
                    }}
                  >
                    change date
                  </Typography>
                </Typography> */}
                        <Typography
                          variant="subtitle1"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <strong style={{ marginRight: "5px" }}>
                            Sample Collected:
                          </strong>
                          {tab === 0
                            ? `${sampleCollectedDate} ${sampleCollectedTime}`
                            : `${widalSampleCollectedDate} ${widalSampleCollectedTime}`}
                          <UpdateIcon
                            sx={{
                              color: "#52b788",
                              marginLeft: 1,
                              "&:hover": { color: "#74c69d" },
                              cursor: "pointer",
                            }}
                            onClick={() => setOpenModal(true)}
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    {requestType !== "edit" && (
                      <Tabs
                        value={tab}
                        onChange={handleChangeTab}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Normal" {...a11yProps(0)} />
                        <Tab label="Widal" {...a11yProps(1)} />
                      </Tabs>
                    )}
                  </Box>

                  {/* <CustomTabPanel value={tab} index={0}> */}
                  {tab === 0 && (
                    <Box>
                      <Grid container spacing={2} mt={1} mb={5}>
                        {/* Header Row */}
                        <Grid item xs={3}>
                          <Typography className={classes.headerText}>
                            <strong>Particulars</strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography className={classes.headerText}>
                            <strong>Results</strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={1}>
                          <Typography className={classes.headerText}>
                            <strong>Ref. Unit</strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography className={classes.headerText}>
                            <strong>Reference Range</strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography className={classes.headerText}>
                            <strong>Method</strong>
                          </Typography>
                        </Grid>
                        {investigations &&
                          investigations.map((item, index) => {
                            return item.investigations.map(
                              (investigation, indx) => (
                                <React.Fragment key={investigation._id}>
                                  {/* Main Investigation */}
                                  <Grid item xs={12}>
                                    <Box
                                      sx={{
                                        backgroundColor: "#e9edc9",
                                        padding: "5px",
                                        borderRadius: "4px",
                                        marginTop: indx === 0 ? 5 : 0,
                                        border: "2px solid #e9edc9",
                                        "&:hover": {
                                          border: "2px solid #89b0ae",
                                        },
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={2}
                                        alignItems="center"
                                        position="relative"
                                      >
                                        {indx === 0 && (
                                          <Typography
                                            fontWeight="bold"
                                            sx={{
                                              position: "absolute",
                                              top: "-28px",
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div style={{ display: "flex" }}>
                                              <Chip
                                                avatar={
                                                  <Avatar
                                                    sx={{
                                                      backgroundColor:
                                                        "#fb8500",
                                                      borderRadius: "50%",
                                                      width: "24px",
                                                      height: "24px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      fontWeight: "bold",
                                                      fontSize: "14px",
                                                      boxShadow:
                                                        "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                      color: "white !important",
                                                    }}
                                                  >
                                                    {index + 1}
                                                  </Avatar>
                                                }
                                                label={item.testId.testName}
                                              />
                                              <div
                                                key={index}
                                                style={{
                                                  marginBottom: "10px",
                                                }}
                                              >
                                                {/* <Typography variant="body1">
                                                {item.name}
                                              </Typography> */}
                                                <Tooltip
                                                  title="Note"
                                                  placement="left"
                                                >
                                                  <IconButton
                                                    sx={{
                                                      fontSize: "2.1rem",
                                                    }}
                                                    onClick={() =>
                                                      hamdleOpenNoteModal(item)
                                                    }
                                                  >
                                                    <EditNoteIcon />
                                                  </IconButton>
                                                </Tooltip>
                                              </div>
                                            </div>
                                            <FormControlLabel
                                              key={item?._id}
                                              control={
                                                <Switch
                                                  size="small"
                                                  color="error"
                                                />
                                              }
                                              label="Sent to other lab"
                                              onChange={() =>
                                                handleOutsideTest(item)
                                              }
                                              checked={
                                                !!resultRecord?.find(
                                                  (i) => i?._id === item?._id,
                                                )?.testId?.isOutside
                                              }
                                            />
                                          </Typography>
                                        )}
                                        <Grid item xs={3} position="relative">
                                          <Typography fontWeight="bold">
                                            {investigation.name}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={2}>
                                          {investigation?.methods?.length >
                                          0 ? (
                                            investigation?.results?.length >
                                            0 ? (
                                              //   <Autocomplete
                                              //     options={investigation?.results || []}
                                              //     getOptionLabel={(option) =>
                                              //       option?.value || ""
                                              //     }
                                              //     freeSolo
                                              //     value={displayResult(
                                              //       index,
                                              //       indx,
                                              //       -1,
                                              //       investigation.methods.find(
                                              //         (m) =>
                                              //           m._id ===
                                              //           selectedMethods[investigation._id]
                                              //       ) || investigation?.methods[0],
                                              //       "investigation"
                                              //     )}
                                              //     onChange={(e, newValue) => {
                                              //       // Clear the previous timeout
                                              //       handleResultChange(
                                              //         newValue.value,
                                              //         index,
                                              //         indx,
                                              //         -1,
                                              //         investigation.methods.find(
                                              //           (m) =>
                                              //             m._id ===
                                              //             selectedMethods[
                                              //               investigation._id
                                              //             ]
                                              //         ) || investigation?.methods[0],
                                              //         "investigation"
                                              //       );
                                              //     }}
                                              //     renderInput={(params) => (
                                              //       <TextField
                                              //         {...params}
                                              //         label="Select Result"
                                              //         variant="outlined"
                                              //         size="small"
                                              //         fullWidth
                                              //         sx={{ background: "white" }}
                                              //         onChange={(e) => {
                                              //           // Clear the previous timeout
                                              //           handleResultChange(
                                              //             e.target.value,
                                              //             index,
                                              //             indx,
                                              //             -1,
                                              //             investigation.methods.find(
                                              //               (m) =>
                                              //                 m._id ===
                                              //                 selectedMethods[
                                              //                   investigation._id
                                              //                 ]
                                              //             ) || investigation?.methods[0],
                                              //             "investigation"
                                              //           );
                                              //         }}
                                              //         value={displayResult(
                                              //           index,
                                              //           indx,
                                              //           -1,
                                              //           investigation.methods.find(
                                              //             (m) =>
                                              //               m._id ===
                                              //               selectedMethods[
                                              //                 investigation._id
                                              //               ]
                                              //           ) || investigation?.methods[0],
                                              //           "investigation"
                                              //         )}
                                              //       />
                                              //     )}
                                              //     disableClearable
                                              //   />
                                              <Autocomplete
                                                options={
                                                  investigation?.results || []
                                                }
                                                getOptionLabel={(option) =>
                                                  option?.value || ""
                                                }
                                                // freeSolo
                                                value={
                                                  investigation?.results?.find(
                                                    (option) =>
                                                      option.value ===
                                                      displayResult(
                                                        index,
                                                        indx,
                                                        -1,
                                                        investigation.methods.find(
                                                          (m) =>
                                                            m._id ===
                                                            selectedMethods[
                                                              investigation._id
                                                            ],
                                                        ) ||
                                                          investigation
                                                            ?.methods[0],
                                                        "investigation",
                                                      ),
                                                  ) || null
                                                }
                                                onChange={(e, newValue) => {
                                                  handleResultChange(
                                                    newValue?.value || "",
                                                    index,
                                                    indx,
                                                    -1,
                                                    investigation.methods.find(
                                                      (m) =>
                                                        m._id ===
                                                        selectedMethods[
                                                          investigation._id
                                                        ],
                                                    ) ||
                                                      investigation?.methods[0],
                                                    "investigation",
                                                  );
                                                }}
                                                isOptionEqualToValue={(
                                                  option,
                                                  value,
                                                ) =>
                                                  option.value === value.value
                                                }
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    label="Select Result"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    sx={{ background: "white" }}
                                                    onChange={(e) => {
                                                      handleResultChange(
                                                        e.target.value,
                                                        index,
                                                        indx,
                                                        -1,
                                                        investigation.methods.find(
                                                          (m) =>
                                                            m._id ===
                                                            selectedMethods[
                                                              investigation._id
                                                            ],
                                                        ) ||
                                                          investigation
                                                            ?.methods[0],
                                                        "investigation",
                                                      );
                                                    }}
                                                  />
                                                )}
                                                disableClearable
                                                disabled={
                                                  reqType === "approval"
                                                }
                                              />
                                            ) : (
                                              <TextField
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                label="Enter result..."
                                                onChange={(e) =>
                                                  handleResultChange(
                                                    //from here
                                                    e.target.value,
                                                    index,
                                                    indx,
                                                    -1,
                                                    investigation.methods.find(
                                                      (m) =>
                                                        m._id ===
                                                        selectedMethods[
                                                          investigation._id
                                                        ],
                                                    ) ||
                                                      investigation?.methods[0],

                                                    "investigation",
                                                  )
                                                }
                                                value={displayResult(
                                                  index,
                                                  indx,
                                                  -1,
                                                  investigation.methods.find(
                                                    (m) =>
                                                      m._id ===
                                                      selectedMethods[
                                                        investigation._id
                                                      ],
                                                  ) ||
                                                    investigation?.methods[0],
                                                  "investigation",
                                                )}
                                                sx={{ background: "white" }}
                                                disabled={
                                                  reqType === "approval"
                                                }
                                              />
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </Grid>
                                        <Grid item xs={1}>
                                          <Typography>
                                            {investigation?.methods?.length > 1
                                              ? getUnit(
                                                  investigation.methods.find(
                                                    (m) =>
                                                      m._id ===
                                                      selectedMethods[
                                                        investigation._id
                                                      ],
                                                  ),
                                                )
                                              : getUnit(
                                                  investigation.methods[0],
                                                )}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                          {investigation?.methods?.length >
                                          1 ? (
                                            selectedMethods[
                                              investigation._id
                                            ] && (
                                              <Typography>
                                                {getRanges(
                                                  investigation.methods.find(
                                                    (m) =>
                                                      m._id ===
                                                      selectedMethods[
                                                        investigation._id
                                                      ],
                                                  ),
                                                )}
                                                {getNote(
                                                  investigation.methods.find(
                                                    (m) =>
                                                      m._id ===
                                                      selectedMethods[
                                                        investigation._id
                                                      ],
                                                  ),
                                                )?.length > 0 && (
                                                  <span
                                                    style={{
                                                      color: "#588157",
                                                      cursor: "pointer",
                                                      fontSize: "12px",
                                                      marginLeft: "5px",
                                                      fontWeight: 800,
                                                    }}
                                                    onClick={() =>
                                                      handleOpenDialog(
                                                        getNote(
                                                          investigation.methods.find(
                                                            (m) =>
                                                              m._id ===
                                                              selectedMethods[
                                                                investigation
                                                                  ._id
                                                              ],
                                                          ),
                                                        ),
                                                      )
                                                    }
                                                  >
                                                    view note
                                                  </span>
                                                )}
                                                <Dialog
                                                  open={openNoteModal}
                                                  onClose={handleCloseDialog}
                                                  maxWidth="sm"
                                                  fullWidth
                                                >
                                                  <DialogTitle>
                                                    Note
                                                  </DialogTitle>
                                                  <DialogContent>
                                                    <Typography>
                                                      {note ||
                                                        "No note available."}
                                                    </Typography>
                                                  </DialogContent>
                                                  <DialogActions>
                                                    <Button
                                                      onClick={
                                                        handleCloseDialog
                                                      }
                                                      color="primary"
                                                    >
                                                      Close
                                                    </Button>
                                                  </DialogActions>
                                                </Dialog>
                                              </Typography>
                                            )
                                          ) : (
                                            <Typography>
                                              {getRanges(
                                                investigation?.methods[0],
                                                index,
                                                indx,
                                              )}
                                              {getNote(
                                                investigation?.methods[0],
                                              )?.length > 0 && (
                                                <span
                                                  style={{
                                                    color: "#588157",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                    marginLeft: "5px",
                                                    fontWeight: 800,
                                                  }}
                                                  onClick={() =>
                                                    handleOpenDialog(
                                                      getNote(
                                                        investigation
                                                          ?.methods[0],
                                                      ),
                                                    )
                                                  }
                                                >
                                                  view note
                                                </span>
                                              )}
                                            </Typography>
                                          )}
                                        </Grid>
                                        <Grid item xs={3}>
                                          {investigation.methods.length > 1 ? (
                                            <Autocomplete
                                              options={
                                                investigation?.methods || []
                                              } // Array of methods for the dropdown
                                              getOptionLabel={(option) =>
                                                option?.methodName || ""
                                              } // Display method name in the dropdown
                                              value={
                                                selectedMethods[
                                                  investigation._id
                                                ]
                                                  ? investigation.methods.find(
                                                      (method) =>
                                                        method._id ===
                                                        selectedMethods[
                                                          investigation._id
                                                        ],
                                                    )
                                                  : ""
                                              }
                                              onChange={(event, newValue) => {
                                                handleMethodChange(
                                                  investigation._id,
                                                  newValue ? newValue._id : "",
                                                );
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Select Method"
                                                  variant="outlined"
                                                  size="small"
                                                  fullWidth
                                                  sx={{ background: "white" }}
                                                />
                                              )}
                                              isOptionEqualToValue={(
                                                option,
                                                value,
                                              ) => option._id === value._id}
                                              disableClearable
                                              disabled={reqType === "approval"}
                                            />
                                          ) : (
                                            <Typography>
                                              {
                                                investigation?.methods[0]
                                                  ?.methodName
                                              }
                                              {/* {handleMethodChange(
                                        investigation._id,
                                        investigation?.methods[0]?._id
                                      )} */}
                                            </Typography>
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Grid>

                                  {/* Sub-Investigations */}
                                  {investigation.subInvestigations.map(
                                    (sub, subIndx) => (
                                      <Grid
                                        xs={12}
                                        key={sub._id}
                                        sx={{ paddingLeft: "16px" }}
                                      >
                                        <Box
                                          sx={{
                                            backgroundColor: "#fefae0",
                                            padding: "5px",
                                            border: "2px solid #fefae0",
                                            "&:hover": {
                                              border: "2px solid #ffa69e",
                                            },
                                          }}
                                        >
                                          <Grid
                                            container
                                            spacing={2}
                                            alignItems="center"
                                          >
                                            <Grid item xs={3}>
                                              <Typography>
                                                {sub.subInvestigationName}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                              {sub?.methods?.length > 0 ? (
                                                sub?.results?.length > 0 ? (
                                                  //   <Autocomplete
                                                  //     options={sub?.results || []} // Array of methods for the dropdown
                                                  //     getOptionLabel={(option) =>
                                                  //       option?.value || ""
                                                  //     } // Display method name in the dropdown
                                                  //     freeSolo
                                                  //     value={displayResult(
                                                  //       index,
                                                  //       indx,
                                                  //       subIndx,
                                                  //       sub.methods.find(
                                                  //         (m) =>
                                                  //           m._id ===
                                                  //           selectedMethods[sub._id]
                                                  //       ) || sub?.methods[0],

                                                  //       "sub-investigation"
                                                  //     )}
                                                  //     onChange={(e, newValue) => {
                                                  //       // Clear the previous timeout
                                                  //       if (typingTimeout)
                                                  //         clearTimeout(typingTimeout);

                                                  //       // Set a new timeout to delay the handleResultChange call
                                                  //       const timeout = setTimeout(() => {
                                                  //         handleResultChange(
                                                  //           newValue.value,
                                                  //           index,
                                                  //           indx,
                                                  //           subIndx,
                                                  //           sub.methods.find(
                                                  //             (m) =>
                                                  //               m._id ===
                                                  //               selectedMethods[sub._id]
                                                  //           ) || sub?.methods[0],

                                                  //           "sub-investigation"
                                                  //         );
                                                  //       }, 1000); // 500ms delay
                                                  //       setTypingTimeout(timeout);
                                                  //     }}
                                                  //     renderInput={(params) => (
                                                  //       <TextField
                                                  //         {...params}
                                                  //         label="Select Result"
                                                  //         variant="outlined"
                                                  //         size="small"
                                                  //         fullWidth
                                                  //         sx={{ background: "white" }}
                                                  //         onChange={(e) => {
                                                  //           // Clear the previous timeout
                                                  //           handleResultChange(
                                                  //             e.target.value,
                                                  //             index,
                                                  //             indx,
                                                  //             subIndx,
                                                  //             sub.methods.find(
                                                  //               (m) =>
                                                  //                 m._id ===
                                                  //                 selectedMethods[sub._id]
                                                  //             ) || sub?.methods[0],

                                                  //             "sub-investigation"
                                                  //           );
                                                  //         }}
                                                  //         value={displayResult(
                                                  //           index,
                                                  //           indx,
                                                  //           subIndx,
                                                  //           sub.methods.find(
                                                  //             (m) =>
                                                  //               m._id ===
                                                  //               selectedMethods[sub._id]
                                                  //           ) || sub?.methods[0],

                                                  //           "sub-investigation"
                                                  //         )}
                                                  //       />
                                                  //     )}
                                                  //     disableClearable
                                                  //   />
                                                  <Autocomplete
                                                    options={sub?.results || []} // Array of results for the dropdown
                                                    getOptionLabel={(option) =>
                                                      option?.value || ""
                                                    } // Display result name in the dropdown
                                                    // freeSolo
                                                    value={
                                                      sub?.results?.find(
                                                        (option) =>
                                                          option.value ===
                                                          displayResult(
                                                            index,
                                                            indx,
                                                            subIndx,
                                                            sub.methods.find(
                                                              (m) =>
                                                                m._id ===
                                                                selectedMethods[
                                                                  sub._id
                                                                ],
                                                            ) ||
                                                              sub?.methods[0],
                                                            "sub-investigation",
                                                          ),
                                                      ) || null
                                                    }
                                                    onChange={(e, newValue) => {
                                                      if (typingTimeout)
                                                        clearTimeout(
                                                          typingTimeout,
                                                        );

                                                      const timeout =
                                                        setTimeout(() => {
                                                          handleResultChange(
                                                            newValue?.value ||
                                                              "",
                                                            index,
                                                            indx,
                                                            subIndx,
                                                            sub.methods.find(
                                                              (m) =>
                                                                m._id ===
                                                                selectedMethods[
                                                                  sub._id
                                                                ],
                                                            ) ||
                                                              sub?.methods[0],
                                                            "sub-investigation",
                                                          );
                                                        }, 1000); // 1-second delay
                                                      setTypingTimeout(timeout);
                                                    }}
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value,
                                                    ) =>
                                                      option.value ===
                                                      value.value
                                                    }
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        label="Select Result"
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        sx={{
                                                          background: "white",
                                                        }}
                                                        onChange={(e) => {
                                                          handleResultChange(
                                                            e.target.value,
                                                            index,
                                                            indx,
                                                            subIndx,
                                                            sub.methods.find(
                                                              (m) =>
                                                                m._id ===
                                                                selectedMethods[
                                                                  sub._id
                                                                ],
                                                            ) ||
                                                              sub?.methods[0],
                                                            "sub-investigation",
                                                          );
                                                        }}
                                                      />
                                                    )}
                                                    disableClearable
                                                    disabled={
                                                      reqType === "approval"
                                                    }
                                                  />
                                                ) : (
                                                  <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    label="Enter result..."
                                                    onChange={(e) => {
                                                      // Clear the previous timeout
                                                      handleResultChange(
                                                        e.target.value,
                                                        index,
                                                        indx,
                                                        subIndx,
                                                        sub.methods.find(
                                                          (m) =>
                                                            m._id ===
                                                            selectedMethods[
                                                              sub._id
                                                            ],
                                                        ) || sub?.methods[0],

                                                        "sub-investigation",
                                                      );
                                                    }}
                                                    value={displayResult(
                                                      index,
                                                      indx,
                                                      subIndx,
                                                      sub.methods.find(
                                                        (m) =>
                                                          m._id ===
                                                          selectedMethods[
                                                            sub._id
                                                          ],
                                                      ) || sub?.methods[0],

                                                      "sub-investigation",
                                                    )}
                                                    sx={{ background: "white" }}
                                                    disabled={
                                                      reqType === "approval"
                                                    }
                                                  />
                                                )
                                              ) : (
                                                ""
                                              )}
                                              {/* <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label="Enter result..."
                                        sx={{ background: "white" }}
                                        onChange={(e) =>
                                          handleResultChange(
                                            e.target.value,
                                            index,
                                            indx,
                                            subIndx,
                                            sub?.methods?.find(
                                              (m) =>
                                                m._id ===
                                                selectedMethods[sub._id]
                                            ) || sub?.methods[0],
                                            "sub-investigation"
                                          )
                                        }
                                      /> */}
                                            </Grid>
                                            <Grid item xs={1}>
                                              <Typography>
                                                {getUnit(
                                                  sub.methods.find(
                                                    (m) =>
                                                      m._id ===
                                                      selectedMethods[sub._id],
                                                  ) || sub?.methods[0],
                                                )}
                                              </Typography>
                                            </Grid>

                                            <Grid item xs={3}>
                                              {sub?.methods?.length > 1 ? (
                                                selectedMethods[sub._id] && (
                                                  <Typography>
                                                    {getRanges(
                                                      sub?.methods?.find(
                                                        (m) =>
                                                          m._id ===
                                                          selectedMethods[
                                                            sub._id
                                                          ],
                                                      ),
                                                    )}
                                                    {getNote(
                                                      sub?.methods?.find(
                                                        (m) =>
                                                          m._id ===
                                                          selectedMethods[
                                                            sub._id
                                                          ],
                                                      ),
                                                    )?.length > 0 && (
                                                      <span
                                                        style={{
                                                          color: "#588157",
                                                          cursor: "pointer",
                                                          fontSize: "12px",
                                                          marginLeft: "5px",
                                                          fontWeight: 800,
                                                        }}
                                                        onClick={() =>
                                                          handleOpenDialog(
                                                            getNote(
                                                              sub?.methods?.find(
                                                                (m) =>
                                                                  m._id ===
                                                                  selectedMethods[
                                                                    sub._id
                                                                  ],
                                                              ),
                                                            ),
                                                          )
                                                        }
                                                      >
                                                        view note
                                                      </span>
                                                    )}
                                                  </Typography>
                                                )
                                              ) : (
                                                <Typography>
                                                  {getRanges(sub?.methods[0])}
                                                  {getNote(sub?.methods[0])
                                                    ?.length > 0 && (
                                                    <span
                                                      style={{
                                                        color: "#588157",
                                                        cursor: "pointer",
                                                        fontSize: "12px",
                                                        marginLeft: "5px",
                                                        fontWeight: 800,
                                                      }}
                                                      onClick={() =>
                                                        handleOpenDialog(
                                                          getNote(
                                                            sub?.methods[0],
                                                          ),
                                                        )
                                                      }
                                                    >
                                                      view note
                                                    </span>
                                                  )}
                                                </Typography>
                                              )}
                                            </Grid>
                                            <Grid item xs={3}>
                                              {sub.methods.length > 1 ? (
                                                <Autocomplete
                                                  options={sub?.methods || []} // Array of methods for the dropdown
                                                  getOptionLabel={(option) =>
                                                    option?.methodName || ""
                                                  } // Display method name in the dropdown
                                                  value={
                                                    selectedMethods[sub._id]
                                                      ? sub.methods.find(
                                                          (method) =>
                                                            method._id ===
                                                            selectedMethods[
                                                              sub._id
                                                            ],
                                                        )
                                                      : null
                                                  } // Find and bind the selected method object
                                                  onChange={(
                                                    event,
                                                    newValue,
                                                  ) => {
                                                    handleMethodChange(
                                                      sub._id,
                                                      newValue
                                                        ? newValue._id
                                                        : "",
                                                    ); // Update state with the selected method's ID
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      label="Select Method"
                                                      variant="outlined"
                                                      size="small"
                                                      fullWidth
                                                      sx={{
                                                        background: "white",
                                                      }}
                                                    />
                                                  )}
                                                  isOptionEqualToValue={(
                                                    option,
                                                    value,
                                                  ) =>
                                                    option._id === value?._id
                                                  } // Ensure accurate comparison
                                                  disableClearable // Prevent clearing the field
                                                  disabled={
                                                    reqType === "approval"
                                                  }
                                                />
                                              ) : (
                                                <Typography>
                                                  {sub?.methods[0]?.methodName}
                                                </Typography>
                                              )}
                                            </Grid>
                                          </Grid>
                                        </Box>
                                      </Grid>
                                    ),
                                  )}
                                </React.Fragment>
                              ),
                            );
                          })}
                      </Grid>
                    </Box>
                  )}
                  {/* </CustomTabPanel> */}

                  {/* <CustomTabPanel value={tab} index={1}> */}
                  {tab === 1 && (
                    <Box>
                      <Widal
                        widalFormData={widalFormData}
                        setWidalFormData={setWidalFormData}
                        selectedInvoice={selectedInvoice}
                        reportType={reqType}
                      />
                    </Box>
                  )}
                  {/* </CustomTabPanel> */}
                  {tab === 1 && (
                    <TextField
                      label="Comments"
                      value={widalFormData?.comment}
                      onChange={(e) =>
                        setWidalFormData((prev) => ({
                          ...prev,
                          comment: e.target.value,
                        }))
                      }
                      multiline
                      rows={4}
                      variant="filled"
                      fullWidth
                      sx={{ mb: 5 }}
                      disabled={reqType === "approval"}
                    />
                  )}

                  {tab === 0 ? (
                    <Card
                      sx={{
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Soft shadow
                        padding: "20px",
                        backgroundColor: "#cce3de", // Clean white background
                        mb: 10,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon
                              icon={faUserDoctor}
                              size="xl"
                              style={{ marginRight: 5 }}
                            />
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-multiple-checkbox-label"
                                size="small"
                              >
                                Signatory Doctor
                              </InputLabel>
                              <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={doctorName}
                                fullWidth
                                size="small"
                                onChange={handleChange}
                                input={
                                  <OutlinedInput label="Signatory Doctor" />
                                }
                                sx={{
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "8px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#115293",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#0d47a1",
                                    },
                                }}
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected
                                      .map(
                                        (id) =>
                                          doctors.find(
                                            (doctor) => doctor._id === id,
                                          )?.name,
                                      ) // Map ID to name
                                      .filter(Boolean) // Remove undefined values
                                      .map((name) => (
                                        <Chip key={name} label={name} />
                                      ))}
                                  </Box>
                                )}
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                }}
                                disabled={reqType === "approval"}
                              >
                                {doctors.map((doctor) => {
                                  const isSelected = doctorName.includes(
                                    doctor._id,
                                  );
                                  const isDisabled =
                                    !isSelected &&
                                    doctorName.length >= maxDoctor;

                                  return (
                                    <MenuItem
                                      key={doctor._id}
                                      value={doctor._id}
                                      disabled={isDisabled}
                                    >
                                      <Checkbox checked={isSelected} />
                                      <ListItemText primary={doctor.name} />
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon
                              icon={faUserNurse}
                              size="xl"
                              style={{ marginRight: 5 }}
                            />

                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-multiple-checkbox-label"
                                size="small"
                              >
                                Technician
                              </InputLabel>
                              <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={techniciansName}
                                fullWidth
                                size="small"
                                onChange={handleChange2}
                                input={<OutlinedInput label="Technician" />}
                                sx={{
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "8px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#115293",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#0d47a1",
                                    },
                                }}
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected
                                      .map(
                                        (id) =>
                                          technicians.find(
                                            (tech) => tech._id === id,
                                          )?.userName,
                                      )
                                      .filter(Boolean)
                                      .map((userName) => (
                                        <Chip key={userName} label={userName} />
                                      ))}
                                  </Box>
                                )}
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                }}
                                disabled={reqType === "approval"}
                              >
                                {technicians.map((tech) => (
                                  <MenuItem key={tech._id} value={tech._id}>
                                    <Checkbox
                                      checked={techniciansName.includes(
                                        tech._id,
                                      )}
                                    />
                                    <ListItemText primary={tech.userName} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  ) : (
                    <Card
                      sx={{
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Soft shadow
                        padding: "20px",
                        backgroundColor: "#cce3de", // Clean white background
                        mb: 10,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon
                              icon={faUserDoctor}
                              size="xl"
                              style={{ marginRight: 5 }}
                            />
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-multiple-checkbox-label"
                                size="small"
                              >
                                Signatory Doctor
                              </InputLabel>
                              <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={widalDoctorName}
                                fullWidth
                                size="small"
                                onChange={widalHandleChange}
                                input={
                                  <OutlinedInput label="Signatory Doctor" />
                                }
                                sx={{
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "8px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#115293",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#0d47a1",
                                    },
                                }}
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected
                                      .map(
                                        (id) =>
                                          doctors.find(
                                            (doctor) => doctor._id === id,
                                          )?.name,
                                      ) // Map ID to name
                                      .filter(Boolean) // Remove undefined values
                                      .map((name) => (
                                        <Chip key={name} label={name} />
                                      ))}
                                  </Box>
                                )}
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                }}
                                disabled={reqType === "approval"}
                              >
                                {doctors.map((doctor) => (
                                  <MenuItem key={doctor._id} value={doctor._id}>
                                    <Checkbox
                                      checked={widalDoctorName?.includes(
                                        doctor._id,
                                      )}
                                    />
                                    <ListItemText primary={doctor.name} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon
                              icon={faUserNurse}
                              size="xl"
                              style={{ marginRight: 5 }}
                            />

                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-multiple-checkbox-label"
                                size="small"
                              >
                                Technician
                              </InputLabel>
                              <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={widalTechniciansName}
                                fullWidth
                                size="small"
                                onChange={widalHandleChange2}
                                input={<OutlinedInput label="Technician" />}
                                sx={{
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "8px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#115293",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#0d47a1",
                                    },
                                }}
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected
                                      .map(
                                        (id) =>
                                          technicians.find(
                                            (tech) => tech._id === id,
                                          )?.userName,
                                      )
                                      .filter(Boolean)
                                      .map((userName) => (
                                        <Chip key={userName} label={userName} />
                                      ))}
                                  </Box>
                                )}
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                }}
                                disabled={reqType === "approval"}
                              >
                                {technicians.map((tech) => (
                                  <MenuItem key={tech._id} value={tech._id}>
                                    <Checkbox
                                      checked={widalTechniciansName?.includes(
                                        tech._id,
                                      )}
                                    />
                                    <ListItemText primary={tech.userName} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                  {reqType !== "approval" ? (
                    <Box
                      sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        backgroundColor: "#fff",
                        //   padding: "20px",
                        boxShadow: "0 -4px 8px rgba(0, 0, 0, 0.1)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        zIndex: 900,
                      }}
                    >
                      {submitLoading && (
                        <LinearProgress
                          color="success"
                          sx={{ height: 2, width: "100%" }}
                        />
                      )}

                      {!submitLoading ? (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            padding: "10px 20px",
                            marginLeft: "auto",
                            backgroundColor: !report ? "#22c55e" : "#fb8500",
                            textTransform: "none",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#16a34a", // darker shades
                            },
                            borderRadius: "0",
                          }}
                          onClick={
                            !report
                              ? tab === 0
                                ? submitResult
                                : submitWidalResult
                              : tab === 0
                                ? updateResult
                                : updateWidalResult
                          }
                        >
                          <Typography>
                            {!report ? "Submit Report" : "Update Report"}{" "}
                          </Typography>
                          <AssessmentIcon sx={{ ml: 1 }} />
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            padding: "10px 20px",
                            marginLeft: "auto",
                            textTransform: "none",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            borderRadius: "0",
                          }}
                          disabled
                        >
                          <Typography>Processing</Typography>
                          <AssessmentIcon sx={{ ml: 1 }} />
                        </Button>
                      )}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        backgroundColor: "#fff",
                        //   padding: "20px",
                        boxShadow: "0 -4px 8px rgba(0, 0, 0, 0.1)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        zIndex: 10000,
                      }}
                    >
                      {submitLoading && (
                        <LinearProgress
                          color="success"
                          sx={{ height: 2, width: "100%" }}
                        />
                      )}

                      <Box sx={{ display: "flex", width: "100%" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            width: "100%",
                            padding: "10px 20px",
                            marginLeft: "auto",
                            backgroundColor: "#ef233c",
                            textTransform: "none",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#d90429",
                              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
                            },
                            borderRadius: "0",
                          }}
                          disabled={submitLoading}
                          onClick={() => approvalOfReport(2)}
                        >
                          <Typography>
                            Resend <ReplyIcon />{" "}
                          </Typography>
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            padding: "10px 20px",
                            width: "100%",
                            marginLeft: "auto",
                            backgroundColor: "#4c956c",
                            textTransform: "none",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#2c6e49",
                              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
                            },
                            borderRadius: "0",
                          }}
                          disabled={submitLoading}
                          onClick={() => approvalOfReport(1)}
                        >
                          <Typography>
                            Approve <ThumbUpIcon />{" "}
                          </Typography>
                        </Button>
                      </Box>
                    </Box>
                  )}
                </>
              )}
          </>
        ) : (
          <Grid container mt={1}>
            <Loader />
          </Grid>
        )}
      </Box>
    </>
  );
};

export default Pathology;
